export enum TripStatusCriteria {
  ALL = 'ALL',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  PLANNED = 'PLANNED',
  LATE = 'LATE',
  ON_TIME = 'ON_TIME',
  LIKELY_LATE = 'LIKELY_LATE'
}
